/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".popup[_ngcontent-%COMP%]{position:absolute;bottom:100%;left:50%;margin-bottom:10px}.popup[_ngcontent-%COMP%]:after{content:'';position:absolute;top:-6px;left:-6px;display:block;width:12px;height:12px;background:#fff;-webkit-transform:rotate(315deg);transform:rotate(315deg);-webkit-box-shadow:-2px 2px 2px rgba(0,0,0,.4);box-shadow:-2px 2px 2px rgba(0,0,0,.4)}.popup__content[_ngcontent-%COMP%]{position:absolute;bottom:100%;left:0;background:#fff;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.4);box-shadow:0 2px 4px rgba(0,0,0,.4);border-radius:5px;-webkit-transform:translateX(-50%);transform:translateX(-50%)}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/components/popup/popup.component.styl.shim.ngstyle.js.pre-build-optimizer.js